import React from 'react';
import { Route } from 'react-router-dom';
import {About} from './Components/About';
import {ProgramSesje} from './Components/ProgramSesje';
import {ProgramRamowy} from './Components/ProgramRamowy';
import {ProgramPosters} from './Components/ProgramPosters';
import {ProgramBook} from "./Components/ProgramBook";
import {ProgramPoster} from "./Components/ProgramPoster";
import {AGHDay} from "./Components/AGHDay";
import {OpenDay} from "./Components/OpenDay";
import {Place} from './Components/Place';
import {Contact} from './Components/Contact';
import {HonoraryPatronage} from './Components/HonoraryPatronage';
import {HonoraryCommittee} from './Components/HonoraryCommittee';
import {OrganizingCommittee} from './Components/OrganizingCommittee';
import {ProgramCommittee} from './Components/ProgramCommittee';
import {ProgramKD} from "./Components/ProgramKD";
import {Main} from './Components/Main';
import {Innowacje2} from './Components/Innowacje2';
import {SponsorsList} from './Components/SponsorsList';
import {SponsorsOffer} from './Components/SponsorsOffer';
import {RegistrationFee} from './Components/RegistrationFee';
import {Hotels} from './Components/Hotels';
import RegistrationForm from './Components/RegistrationForm';
import {Innowacje} from "./Components/Innowacje";
import {PageGallery} from "./Components/PageGallery";
import {Gallery} from "./Components/Gallery";
import {Movies} from "./Components/Movies";
import {Proceedings} from "./Components/Proceedings";
import {ConcertMaximum} from "./Components/ConcertMaximum";
import {ConcertOpera} from "./Components/ConcertOpera";


export default (
    <React.Fragment>
        <Route exact path="/" component={Main} />
        <Route path="/o-zjezdzie" component={About} />
        <Route path="/program/ramowy" component={ProgramRamowy} />
        <Route path="/program/sesje" component={ProgramSesje} />
        <Route path='/program/harmonogram-online' component={() => {
                    window.location.href = 'https://reg.45zfp.if.uj.edu.pl/event/1/timetable/#all.detailed';
                    return null;
        }}/>
        <Route path="/program/konferencja-dydaktyczna" component={ProgramKD} />
        <Route path="/program/dzien-agh" component={AGHDay} />
        <Route path="/program/sesja-plakatowa" component={ProgramPosters} />
        <Route path="/program/ksiazka-streszczen" component={ProgramBook} />
        <Route path="/program/plakat-konferencyjny" component={ProgramPoster} />
        <Route path="/atrakcje/dzien-otwarty" component={OpenDay} />
        <Route path="/miejsce" component={Place} />
        <Route path="/komitety/patronat-honorowy" component={HonoraryPatronage} />
        <Route path="/komitety/honorowy" component={HonoraryCommittee} />
        <Route path="/komitety/organizacyjny" component={OrganizingCommittee} />
        <Route path="/komitety/programowy" component={ProgramCommittee} />
        <Route path="/kontakt" component={Contact} />
        <Route path="/sesja-innowacje" component={Innowacje2} />
        <Route path="/sponsorzy/lista-sponsorow" component={SponsorsList} />
        <Route path="/sponsorzy/oferta-wspolpracy" component={SponsorsOffer} />
        <Route path="/rejestracja/oplaty-konferencyjne" component={RegistrationFee} />
        <Route path="/rejestracja/formularz-rejestracyjny" component={RegistrationForm} />
        <Route path="/rejestracja/zakwaterowanie" component={Hotels} />
        <Route path="/rejestracja/sesja-innowacje" component={Innowacje} />
        <Route path="/po-zjezdzie/galeria/:day" exact component={PageGallery}/>
        <Route path="/po-zjezdzie/galeria" exact component={Gallery}/>


        <Route path="/po-zjezdzie/nagrania-wykladow" component={Movies}/>
        <Route path="/po-zjezdzie/proceedings" component={Proceedings}/>
        <Route path="/po-zjezdzie/nagranie-widowisko-multimedialne" component={ConcertMaximum}/>
        <Route path="/po-zjezdzie/nagranie-koncert-w-operze" component={ConcertOpera}/>


    </React.Fragment>
);
